import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TUserCode {
  userCode: string;
  user: string;
}

export interface IUserCode extends TUserCode {}

const UserCode = Model(
  (model: TUserCode): IUserCode => {
    const _userCode: TUserCode = Object.assign({}, model);

    let create = (userCode: IUserCode): IUserCode => {
      let obj = ValidatableObject(userCode);
      return obj;
    };

    let userCode = {
      get userCode() {
        return _userCode.userCode;
      },
      set userCode(value) {
        _userCode.userCode = value;
      },
      get user() {
        return _userCode.user;
      },
      set user(value) {
        _userCode.user = value;
      }
    };

    return create(userCode);
  }
);

export default UserCode;
